<template>
  <page-wrapper :title="title" :hasPad="true">
    <div class="mb-4">
      <package-selector v-model="form" is-action-edit="true"></package-selector>
    </div>
    <div class="text-right">
      <sc-button variant="primary" @click="handleClickSave">บันทึก</sc-button>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import { baanRueJaiClient } from "@/dependencies";
import { toCamelCaseObject } from "@/lib/util";
import PackageSelector from "../../collections/components/PackageSelector";

export default {
  components: {
    PageWrapper,
    ScButton,
    PackageSelector
  },
  data() {
    const title = "จัดลำดับการแสดงผล";
    const form = [];

    return {
      title,
      form
    };
  },
  computed: {},
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    setupData() {
      this.setupForm();
    },
    async setupForm() {
      const form = await this.fetchOrderingPackages();

      this.form = form;
    },
    async fetchOrderingPackages() {
      try {
        const response = await baanRueJaiClient.admin.subscriptions.recommend_packages.getOrder();

        return response.data.result.map(item => {
          const {
            id,
            name,
            price,
            billing_cycle: billingCycle,
            detail,
            service_ids,
            project_ids,
            image_url: imageUrl,
            target
          } = item;

          return {
            id: id.toString(),
            name: name,
            target,
            price,
            billingCycle,
            detail,
            serviceCount: service_ids.length,
            projectCount: (project_ids || []).length,
            imageUrl
          };
        });
      } catch (err) {
        if (err.response && err.response.status === 500) {
          console.warn(
            "no route for getting ordering package, return [] as default"
          );
          return [];
        }

        throw err;
      }
    },
    async handleClickSave() {
      const params = { ids: this.form.map(({ id }) => +id) };

      try {
        const response = await baanRueJaiClient.admin.subscriptions.recommend_packages.postOrder(
          params
        );
        alert("จัดลำดับเรียบร้อย");
      } catch (err) {
        alert("เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง");
        console.error(err);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.wrapper {
  padding: $space 0;
}

.editor {
  margin-bottom: $space;
}
</style>



// WEBPACK FOOTER //
// src/features/subscriptions/modules/packages/pages/PackageOrderingPage.vue